import { TLanguage } from 'config/tenancy';
import {
  isCIDIMEXValid,
  isCIValid,
  isCPFValid,
  isDNIValid,
} from 'shared/presentation/helpers';

export const DOCUMENT_VALIDATORS: Record<
  TLanguage,
  (document: string) => boolean
> = {
  pt: isCPFValid,
  es: isCIValid,
  'es-CR': isCIDIMEXValid,
  'es-UY': isDNIValid,
};
